import { Asset } from '@gripp/shared-logic';
import { Button, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

type ActionButtonsProps = {
  onCompleted: (message: string, messageDownloadApp: string) => void;
  asset: Asset;
  workspaceId: string;
  // Triggers the parent's in-page report/note swap instead of a modal.
  onAddNew?: () => void;
};

export const ActionButtons = (props: ActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    // Full-width primary action floating at the bottom of the page.
    // The wrapper's height pins this flex child so it doesn't collapse
    // to 0 on web inside the BottomComponentBar's flex-column wrapper.
    // The form itself is rendered in-page by the parent via onAddNew (no modal).
    <View style={ccStyles.actionWrapper}>
      <Button style={ccStyles.button} onPress={props.onAddNew} state="active">
        {`+ ${t('asset.header.buttons.addNew')}`}
      </Button>
    </View>
  );
};

const ccStyles = StyleSheet.create({
  actionWrapper: {
    flexGrow: 1,
    height: 56,
    marginLeft: tokens.spacing.lg,
    flexDirection: 'row',
  },
  button: {
    flex: 1,
    height: 56,
    maxHeight: 56,
    borderRadius: tokens.borderRadius.xs,
    backgroundColor: tokens.colors.orange[500],
  },
});
